module.exports = __webpack_public_path__ + "img/new_small_map_marker.0e4eaed7.png";